import { Injectable } from '@angular/core';

@Injectable()
export default class MsCotista {
  constructor() {}
  // tslint:disable-next-line: max-line-length
  sendAdhesionContract = 'mutation ($investor: Investor!, $investmentFund: InvestmentFund!, $termoAdesaoType: String!, url: String!) {  CreateTermoAdesao(investor: $investor, investmentFund: $investmentFund, termoAdesaoType: $termoAdesaoType, url: $url){id}}';

  // tslint:disable-next-line: max-line-length
  getAdhesionContracts = 'query ($indexer: String!) {  Cotista(indexer: $indexer) {    termoAdesao {      s3 investmentFund {name document portfolio { name  number } } fundDistributor{name document} createdAt  sign {isSigned, vxSignId}   }  }}';

  // tslint:disable-next-line: max-line-length
  getNonConformityTerm = 'query ($indexer: String!) {  Cotista(indexer: $indexer) {    termoDesenquadramento {      s3 investmentFund { name document } fundDistributor{ name document} createdAt  sign {isSigned, vxSignId}   }  }}';
}
